<template>
  <nav class="items-per-page" v-bind:class="[{ 'disabled': loading.state }]">
    <a href="" v-for="elem in $lang.items_per_page.elems" v-bind:title="elem.name"
       v-on:click.prevent="setActiveRow(elem.val)" class="items-per-page__button" v-bind:class="[{ 'active': rowsNum == elem.val}]">
          {{ elem.val }}
    </a>
    <span class="items-per-page__text">{{ $lang.items_per_page.label }}</span>
  </nav>
</template>

<script>

// load shared methods from itemsPerPage module
import setActiveRow from './../../scripts/modules/items-per-page'
import { mapGetters } from 'vuex'

export default {
  name: 'itemsPerPage',
  data () {
    return {

    }
  },
  methods: {
    setActiveRow: function(n) {
      return setActiveRow(n)
    }
  },
  computed: {
    ...mapGetters({
      loading: 'GET_LOADING_STATE',
      rowsNum: 'GET_ROWS_NUM',
      totalPagesNum: 'GET_TOTAL_PAGES_NUM',
      searchResultsNum: 'GET_SEARCH_RESULTS_NUM'
    })
  }
}
</script>



// WEBPACK FOOTER //
// ItemsPerPage.vue?cffc4498